import axios from '../../axios/index.js'
import store from '../../../store/store.js'


export default {
   
    getAllOvertime(sortBy, sortOrder, pageNumber, pageSize, isApprover) {
        return axios.get('/api/overtime', { params : {
            sortBy: sortBy,
            sortOrder: sortOrder,
            pageNumber: pageNumber,
            pageSize: pageSize,
            isApprover: isApprover
        }})
    },

    
}